export default {
	nome_column_not_found: "Arquivo não contém a coluna 'nome'",
	numero_column_not_found: "Arquivo não contém a coluna 'numero'",
	all_columns_not_found: "Nenhuma das colunas requiridas foram encontradas, verifique se o arquivo está separado por vírgula ou ponto e vírgula"
}
